import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ClientDashboardCard } from '../../../components/ClientDashboard';
import { CommonHeader } from '../../../components/commons';
import { useMenuCheck } from '../../../customHooks/useMenuCheck';
import { RootState } from '../../../redux/rootReducers';

type AppProps = {
  history?: any;
  modules: any[];
}

const StockManager = ({
  history,
  modules
}: AppProps) => {

  const company_name = history?.location?.state?.company_name;
  const client_code = history?.location?.state?.client_code;



  //===============================User Management============================
const [isStockManagerUrlPresent,setIsStockManagerUrlPresent]=useMenuCheck()
//=============================================================================

  useEffect(()=>{
    setIsStockManagerUrlPresent("/stock-manager","url")
     //eslint-disable-next-line
  },[])



  useEffect(()=>{
   if(isStockManagerUrlPresent===false){
    history.push("/access-denied")
   }
    //eslint-disable-next-line
  },[isStockManagerUrlPresent])


  const handleRedirection = (moduleName: string | undefined) => {
    
    
    switch (moduleName) {
      case 'redirectToStockGroups':
        return redirectToStockGroups();
      case 'redirectToStockItems':
        return redirectToStockItems();
      case 'redirectToUnitsOfMeasurement':
        return redirectToUnitsOfMeasurement();
      default:
        return null;
    }
  };

  const redirectToStockGroups = () => {
    history.push({
      pathname: `/client-settings/stock-manager/stock-groups-list/${ client_code }`,
      state: { client_code, company_name }
    });
  };

  const redirectToStockItems = () => {
    history.push({
      pathname: `/client-settings/stock-manager/stock-items-list/${ client_code }`,
      state: { client_code, company_name }
    });
  };

  const redirectToUnitsOfMeasurement = () => {
    history.push({
      pathname: `/client-settings/stock-manager/units-of-measurement/${ client_code }`,
      state: { client_code, company_name }
    });
  }
  
  let settings: any = modules && modules?.length > 0 && modules?.filter(menu => menu?.menu_name === 'Settings');
  let stockManager= settings[0].sub_menu && settings[0]?.sub_menu.length > 0 && settings[0]?.sub_menu?.filter((menu:any) => menu?.menu_name === 'Stock Manager')

  const renderModules = () => {
    let finalList = stockManager[0]?.sub_menu?.map((list:any) => {
      return (
        <div className={`col-md-4 mb-4 ${ list.extraClasses }`}>
          <ClientDashboardCard
            isNew={list.is_new}
            key={list.menu_name}
            name={list.menu_name}
            description={list.description}
            icon={<i className={list.icon}></i>}
            action={() => handleRedirection(list.action)}
            comingSoon={list.comingSoon}
          />
        </div>
      )
    });

    return finalList;
  };

  return <>
    <CommonHeader
      title='Stock Manager'
      company_name={company_name}
      client_code={client_code}
    />
    <div className="row mt-3">
      {renderModules()}
    </div>
  </>
};

const mapStateToProps = (state: RootState) => ({
  modules: state.auth.modules
})

export default connect(mapStateToProps) (StockManager);